<template>
<div>
    <div v-if="!isClientUser">
        <h3>Cultural Resources</h3>
        <loader v-show="isLoading" />
        <div style="float: clear" v-show="!isLoading">
            <v-client-table :data="culturalResourceList" :columns="crGridSpec.columns" :options="crGridSpec.options" ref="culturalResourceGrid">
                <template slot="view" slot-scope="props">
                    <div style="text-align: center">
                        <!-- <a v-if="props.row.workflowInstanceId" class="fa fa-edit" style="font-size: 18px;" v-on:click="goRecording(props.row.culturalResourceRecordingId)"></a> -->
                        <router-link v-if="props.row.workflowInstanceId" :to="{ path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId, hash: '#eligibility' }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                    </div>
                </template>
            </v-client-table>
            <div v-if="crAssignAvailable">
                <button class="btn btn-primary" v-on:click="openCrUserAssign()">Cultural Resources User Assignment</button>
                <modal ref="crUserAssignModal">
                    <div slot="header" class="row">
                        <h3 class="pull-left">Cultural Resources User Assignment</h3>
                        <button class="btn pull-right" v-on:click="closeCrUserAssign()">X</button>
                    </div>
                    <div slot="body">
                        <h4>Filter By Time Period</h4>
                        <div>
                            <select id="timePeriodFilter" class="form-control" v-on:change="filterCrAssignmentList($event)">
                                <option :value="0">All Time Periods</option>
                                <option v-for="period in crTimePeriodList" v-bind:key="period.timePeriodId" v-bind:value="period.timePeriodId">
                                    {{ period.timePeriodDescription}}
                                </option>
                            </select>
                        </div>
                        <div class="spacer">
                            <button v-if="crModalSelectToggle" class="btn btn-default" v-on:click="selectAllCrAssignment(true)">Select All</button>
                            <button v-if="!crModalSelectToggle" class="btn btn-default" v-on:click="selectAllCrAssignment(false)">Un-Select All</button>
                            <v-client-table :data="crAssignmentList" :columns="assignGridSpec.columns" :options="assignGridSpec.options">
                                <template slot="select" slot-scope="props">
                                    <div style="text-align: center">
                                        <input class="form-check-input" style="width: 18px; height: 18px;" type="checkbox" v-model="selectedAssignmentList"
                                        v-bind:id="props.row.culturalResourceRecordingId" v-bind:value="props.row.culturalResourceRecordingId" />
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                        <div class="spacer">
                            <h4>Assign User and Submit Workflow</h4>
                            <form @submit.prevent class="form-horizontal" data-vv-scope="workflowSubmit">
                                <div class="form-group">
                                    <label class="col-md-2 control-label">Workflow Action</label>
                                    <div class="col-md-4">
                                        <select name="workflowStatusId" class="form-control" v-model="crWorkflowStatusId" v-validate="'required'">
                                            <option disabled value="">Select action</option>
                                            <option v-for="item in crWorkflowStatusDtoNextList" v-bind:key="item.workflowStatusId" v-bind:value="item.workflowStatusId">
                                                {{ item.submitDescription}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group" v-if="assignableUserList.length > 0" v-bind:class="{ 'has-error': errors.has('workflowSubmit.assignedUserId') }">
                                    <label class="col-md-2 control-label">Assign User</label>
                                    <div class="col-md-6">
                                        <select name="crAssignedUserId" class="form-control" v-model="crAssignedUserId" v-validate="'required'">
                                            <option disabled value="">Select user to assign</option>
                                            <option v-for="item in assignableUserList" v-bind:key="item.userId" v-bind:value="item.userId">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                        <div><span v-show="errors.has('workflowSubmit.crAssignedUserId')" class="has-error">Assign User is required</span></div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label">Note</label>
                                    <div class="col-md-6">
                                        <textarea name="crNotes" class="form-control" v-model="crNotes" placeholder="Notes"></textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label">&nbsp;</label>
                                    <div class="col-md-4">
                                        <validationResultDisplay :validationResult="crValidationResult"></validationResultDisplay>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label">&nbsp;</label>
                                    <div class="col-md-2">
                                        <button class="btn btn-primary btn-block" v-on:click="crWorkflowSubmit">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div slot="footer">
                        <div class="row">
                            <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="closeCrUserAssign()">Close</button>
                        </div>
                    </div>
                </modal>
            </div>
        </div>
        <div style="float: clear; margin-top:20px;" v-show="!isLoading" v-if="enableNotLocatedSites">
            <h4>Not Located Sites</h4>
            <v-client-table :data="crrNotLocatedList" :columns="crrNotLocatedGridSpec.columns" :options="crrNotLocatedGridSpec.options" ref="crrNotLocatedGrid">
                <template slot="siteNarrative" slot-scope="props">
                    <div :class="{'form-inline': isConsultantOnly || isAdmin}">
                        <textarea style="min-width: 75%;" :disabled="!isConsultantOnly && !isAdmin" type="textarea" class="form-control" rows="1" v-model="props.row.siteNarrative" />
                        <button v-if="(isConsultantOnly || isAdmin) && enableNotLocatedSites" :disabled="isNotLocatedCrrSaving" class="btn btn-primary" type="button" v-on:click="saveNotLocatedCrr(props.row)">Save</button>
                    </div>
                </template>
            </v-client-table>
        </div>
        <h3 class="spacer">Isolate Resources</h3>
        <loader v-show="isLoading" />
        <div style="float: clear" v-show="!isLoading">
            <v-client-table :data="isolateList" :columns="isolateGridSpec.columns" :options="isolateGridSpec.options" ref="isolateGrid">
                <template slot="view" slot-scope="props">
                    <div style="text-align: center">
                        <router-link v-if="props.row.workflowInstanceId" :to="{ path: '/Isolate/' + props.row.isolateId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                    </div>
                </template>
            </v-client-table>
        </div>
    </div>
    <div>
        <h3>Submission</h3>
        <workflow :workflowId="3000" :parentId="investigation.investigationId" :investigation="investigation" ref="workflow" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"></workflow>
    </div>
</div>
</template>

<script>
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'
import isolateService from '@/services/isolateService'
import loggingService from '@/services/util/loggingService'
import workflowService from '@/services/workflowService'
import undertakingService from '@/services/undertakingService'
import workflow from '@/components/Workflow.vue'
import modal from '@/components/Modal.vue'
import validationResultDisplay from '@/components/ValidationResultDisplay.vue'
import loader from '@/components/Loader.vue'

export default {
    name: 'SiteSummary',
    components: {
        workflow,
        modal,
        validationResultDisplay,
        loader
    },
    props: {
        investigation: {},
        loadOnMount: { default: true },
        isConsultantOnly: { default: false },
        isClientUser: { default: false },
        isAdmin: { default: false }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            culturalResourceList: [],
            crGridSpec: {
                columns: ['view', 'workflowStatusDescription', 'smithsonianNumber', 'recordingType', 'siteType', 'timePeriodDescription',
                    'previousEligibility', 'contractorEligibility', 'contractorEffect', 'agencyEligibility', 'agencyEffect', 'shpoEligibility',
                    'shpoEffect', 'criteria', 'inAPE', 'owner', 'collections', 'assignedUser'],
                options: {
                    perPage: 100,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        view: 'View',
                        workflowStatusDescription: 'Status',
                        smithsonianNumber: 'Smithsonian Number',
                        recordingType: 'Recording Type',
                        siteType: 'Site Type',
                        timePeriodDescription: 'Time Period',
                        //effect: 'Effect',
                        previousEligibility: 'Previous Eligibility',
                        contractorEligibility: 'Contractor Eligibility',
                        contractorEffect: 'Contractor Effect',
                        agencyEligibility: 'Agency Eligibility',
                        agencyEffect: 'Agency Effect',
                        shpoEligibility: 'SHPO Eligibility',
                        shpoEffect: 'SHPO Effect',
                        criteria: 'Criteria',
                        inAPE: 'In APE',
                        owner: 'Landowner',
                        collections: 'Collections',
                        assignedUser: 'Assigned SHPO User'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'smithsonianNumber'
                    }
                }
            },
            crrNotLocatedList: [],
            crrNotLocatedGridSpec: {
                columns: ['smithsonianNumber', 'recordingType', 'siteType', 'timePeriodDescription',
                    'previousEligibility', 'siteNarrative'],
                options: {
                    perPage: 100,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        smithsonianNumber: 'Smithsonian Number',
                        recordingType: 'Recording Type',
                        siteType: 'Site Type',
                        timePeriodDescription: 'Time Period',
                        previousEligibility: 'Previous Eligibility',
                        siteNarrative: 'Comments'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'smithsonianNumber'
                    }
                }
            },
            isolateList: [],
            isolateGridSpec: {
                columns: ['view', 'workflowStatusDescription', 'isolateNumber', 'isolateCurationId', 'resourceType', 'landOwner', 'collections'],
                options: {
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        view: 'View',
                        workflowStatusDescription: 'Status',
                        isolateNumber: 'File Number',
                        isolateCurationId: 'Curation Number',
                        resourceType: 'Resource Type',
                        landOwner: 'Land Owner',
                        collections: 'Collections'
                    }
                }
            },
            crAssignmentList: [],
            selectedAssignmentList: [],
            assignGridSpec: {
                columns: ['select', 'workflowStatusDescription', 'smithsonianNumber', 'siteType', 'timePeriodDescription'],
                options: {
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        select: 'Select',
                        workflowStatusDescription: 'Status',
                        smithsonianNumber: 'Smithsonian Number',
                        siteType: 'Site Type',
                        timePeriodDescription: 'Time Period'
                    },
                    filterable: false
                }
            },
            crModalSelectToggle: true,
            crAssignAvailable: false,
            crWorkflowStatusDtoNextList: [],
            crWorkflowStatusId: culturalResourceRecordingService.WorkflowStatusEnum.PendingSHPOApproval,
            crAssignedUserId: '',
            crNotes: '',
            crValidationResult: {
                messages: []
            },
            isNotLocatedCrrSaving: false,
            enableNotLocatedSites: false
        }
    },
    computed: {
        crTimePeriodList: function () {
            var list = []
            var timePeriod = culturalResourceRecordingService.TimePeriodEnum
            for (var prop in timePeriod) {
                list.push({ timePeriodId: timePeriod[prop], timePeriodDescription: prop })
            }
            return list
        },
        assignableUserList: function () {
            var selected = this.crWorkflowStatusDtoNextList.find(workflow => {
                return +workflow.workflowStatusId === +this.crWorkflowStatusId
            })
            if (selected) {
                return selected.assignableUserList
            } else {
                return []
            }
        }
    },
    watch: {
        'investigation.investigationId': function () {
            this.loadData()
        }
    },
    mounted () {
        if (this.loadOnMount) this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Summary', message)
        },
        loadSites () {
            this.log('Looking for sites on investigation' + this.investigation.investigationId)
            var searchDto = {investigationId: this.investigation.investigationId}
            return culturalResourceRecordingService.searchSummary(this.$http, searchDto).then(response => {
                this.log('SearchSummary done. found: ' + response.data.length)
                this.culturalResourceList = response.data.map(recording => {
                    recording.inAPE = recording.inAPE ? 'Yes' : 'No'
                    recording.previouslyRecorded = recording.previouslyRecorded ? 'Yes' : 'No'
                    recording.timePeriodDescription = `${recording.timePeriodId}:${recording.timePeriodDescription}`
                    return recording
                })
                // set assignable site list
                this.resetCrAssignmentList()
                if (this.crAssignmentList.length > 0) {
                    this.crAssignAvailable = true
                    // load cr workflow data
                    var crrId = this.crAssignmentList[0].culturalResourceRecordingId
                    workflowService.getWorkflowInstanceDto(this.$http, workflowService.WorkflowEnum.CulturalResourceRecording, crrId).then(response => {
                        var workflowInstanceDto = response.data
                        workflowService.listNextWorkflowStatusDto(this.$http, workflowInstanceDto.workflowInstanceId).then(response2 => {
                            this.crWorkflowStatusDtoNextList = response2.data
                            if (this.crWorkflowStatusDtoNextList.length === 0) {
                                this.crAssignAvailable = false
                            }
                        })
                    })
                }
                return response
            })
        },
        loadNotLocatedSites () {
            if (!this.enableNotLocatedSites) return
            this.log('Looking for not located sites on investigation' + this.investigation.investigationId)
            var searchDto = {investigationId: this.investigation.investigationId}
            return culturalResourceRecordingService.searchSummaryNotLocated(this.$http, searchDto).then(response => {
                this.log('searchSummaryNotLocated done. found: ' + response.data.length)
                this.crrNotLocatedList = response.data.map(recording => {
                    recording.inAPE = recording.inAPE ? 'Yes' : 'No'
                    recording.previouslyRecorded = recording.previouslyRecorded ? 'Yes' : 'No'
                    recording.timePeriodDescription = `${recording.timePeriodId}:${recording.timePeriodDescription}`
                    return recording
                })
                return response
            })
        },
        loadIsolates () {
            var searchDto = {investigationId: this.investigation.investigationId}
            this.log('Searching for isolates for investigation: ' + searchDto.investigationId)
            return isolateService.search(this.$http, searchDto).then(response => {
                this.isolateList = response.data
                return response
            })
        },
        loadData () {
            if (this.isClientUser) return
            if (!this.investigation.investigationId) {
                this.log('No investigation Id yet')
            } else {
                this.isLoading = true
                Promise.all([this.loadSites(), this.loadIsolates(), this.loadNotLocatedSites()]).then(response => {
                    this.log('Done loading data')
                    //pass investigation undertakingId to workflow submit's undertaking model
                    if (!this.isConsultantOnly && this.investigation.undertakingId) {
                        undertakingService.get(this.$http, this.investigation.undertakingId).then(response => {
                            loggingService.logRaw(this.isDebug, response.data)
                            var undertakingModal = this.$refs.workflow.$refs.workflowSubmit.$refs.undertakingModal
                            loggingService.logRaw(this.isDebug, undertakingModal)
                            if (undertakingModal) {
                                undertakingModal.assignedUndertaking = response.data
                            }
                        })
                    }
                    this.isLoading = false
                })
            }
        },
        goRecording (culturalResourceRecordingId) {
            loggingService.log(this.isDebug, 'CRSelection', 'Go to recording:' + culturalResourceRecordingId)
            this.$router.push('/CulturalResourceRecording/' + culturalResourceRecordingId)
        },
        goIsolate (isolateId) {
            this.$router.push('/Isolate/' + isolateId)
        },
        resetCrAssignmentList () {
            this.crModalSelectToggle = true
            this.selectedAssignmentList = []
            this.crAssignmentList = this.culturalResourceList.filter(site => site.workflowStatusId === culturalResourceRecordingService.WorkflowStatusEnum.PendingSHPOAssignment)
        },
        openCrUserAssign () {
            this.resetCrAssignmentList()
            this.$refs['crUserAssignModal'].open()
        },
        closeCrUserAssign () {
            this.resetCrAssignmentList()
            this.cleanCrWorkflow()
            document.getElementById('timePeriodFilter').value = 0
            this.$refs['crUserAssignModal'].close()
        },
        selectAllCrAssignment (select) {
            this.crModalSelectToggle = !this.crModalSelectToggle
            this.selectedAssignmentList = []
            if (select) {
                this.crAssignmentList.forEach(site => {
                    this.selectedAssignmentList.push(site.culturalResourceRecordingId)
                })
            }
        },
        filterCrAssignmentList (event) {
            this.resetCrAssignmentList()
            if (+event.target.value !== 0) {
                this.crAssignmentList = this.crAssignmentList.filter(site => +site.timePeriodId === +event.target.value)
            }
        },
        cleanCrWorkflow () {
            this.crAssignedUserId = ''
            this.crNotes = ''
        },
        crWorkflowSubmit () {
            if (this.selectedAssignmentList.length === 0) {
                alert('No Cultural Resources selected')
                return
            }
            var selectedList = this.crAssignmentList.filter(site =>
                this.selectedAssignmentList.includes(+site.culturalResourceRecordingId)
            )
            var promises = []
            selectedList.forEach(site => {
                var newPromise = workflowService.submit(this.$http, site.workflowInstanceId, this.crWorkflowStatusId, this.crNotes, this.crAssignedUserId)
                promises.push(newPromise)
            })
            Promise.all(promises).then(results => {
                this.crValidationResult.messages = []
                results.forEach(result => {
                    this.crValidationResult.messages = this.crValidationResult.messages.concat(result.data.messages)
                })
                if (this.crValidationResult.messages.length === 0) {
                    this.closeCrUserAssign()
                } else {
                    this.cleanCrWorkflow()
                }
                this.loadSites()
            })
        },
        //trigger on workflowOnSubmitSuccess
        workflowOnSubmitSuccess (validationResult) {
            this.$emit('workflowOnSubmitSuccess', validationResult)
        },
        saveNotLocatedCrr (crrDto) {
            this.isNotLocatedCrrSaving = true
            return culturalResourceRecordingService.putNotLocatedCrr(this.$http, crrDto).then(response => {
                this.isNotLocatedCrrSaving = false
                return response
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// SiteSummary.vue?087511c2